import React from "react";
import styled from "styled-components";
import { Link, colors, font } from "@literati/public-ui-shared-react";

export interface MembershipOfferBannerProps {
  className?: string;
  claimHref?: string;
  isClaimed?: boolean;
  onClaimClick?: () => void;
}

const SpecialOfferMain = styled.div.attrs({})`
  width: 100vw;
  padding: 0.625rem 1rem;
  background: ${colors.periwinkleShade1};
  color: ${colors.white};
  text-align: center;
`;

const InnerWrapper = styled.div.attrs({})`
  font-family: ${font.fontFamily.avenir};
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
`;

const ClaimLink = styled(Link)`
  margin-left: 0.25rem;
  color: inherit;
  font-size: 1rem;
  text-decoration: underline;
  cursor: pointer;

  &:hover,
  &:active,
  &:visited,
  &:focus {
    color: inherit;
  }
`;

const ClaimedMain = styled.span.attrs({})`
  display: inline-flex;
  align-items: center;
  margin-left: 0.5rem;
`;

const ClaimSvg = styled.span.attrs({})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${colors.literatiTeal};
  border-radius: 50%;
  padding: 0.25rem;
  margin: 0 0.25rem;
`;

const ClaimedText = styled.span.attrs({})`
  margin-left: 0.25rem;
`;

export const MembershipOfferBanner = ({
  className = "",
  claimHref = "#",
  isClaimed = false,
  onClaimClick,
}: MembershipOfferBannerProps) => {
  const handleClaimClick: React.MouseEventHandler<HTMLElement> = (event) => {
    if (claimHref === "#") {
      event.preventDefault();
    }
    onClaimClick?.();
  };

  return (
    <SpecialOfferMain className={`special-offer-main ${className}`.trim()}>
      <InnerWrapper className="speical-offer-inner-wrapper">
        First 3 Months Just $4.95/mo —{" "}
        {isClaimed ? null : (
          <ClaimLink href={claimHref} onClick={handleClaimClick}>
            Claim My Offer
          </ClaimLink>
        )}
        {isClaimed ? (
          <ClaimedMain className="claimed-main">
            <ClaimSvg className="claim-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M10 3L4.5 8.5L2 6"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </ClaimSvg>
            <ClaimedText className="top-bar-claim-txt">Claimed!</ClaimedText>
          </ClaimedMain>
        ) : null}
      </InnerWrapper>
    </SpecialOfferMain>
  );
};

export default MembershipOfferBanner;
